import { Navigate, useParams } from 'react-router-dom';

import i18n from '@/i18n';
import AppLayout from '@/layout/AppLayout';
import { lazyNamedImport } from '@/utils/lazyNamedImport';

/** 下单创建页：与其它业务页一致，JS + CSS Modules 随路由 lazy */
const CreateOrder = lazyNamedImport(() => import('@/pages/order'), 'CreateOrder');
const t = i18n.t.bind(i18n);

/** 访问 `/ws/:ws/dc/:dc/order` 时跳转到创建订单页 */
function OrderEntryRedirect() {
  const { ws, dc } = useParams<{ ws: string; dc: string }>();
  return <Navigate to={`/ws/${ws}/dc/${dc}/order/create-order`} replace />;
}

/** 订单路由 */
export const orderRouters = {
  path: '/',
  element: <AppLayout />,
  title: t('order:title'),
  children: [
    {
      path: '/ws/:ws/dc/:dc/order',
      element: <OrderEntryRedirect />,
    },
    {
      path: '/ws/:ws/dc/:dc/order/create-order',
      element: <CreateOrder />,
    },
  ],
};
